import { DataBean } from "../DataBean";

export class AccountantYear extends DataBean {



    public async getAccountantYearConstants(id): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getAccountantYearConstants_Number", [id]);
    }
}